import { currencies, CurrencyWrapper } from "./CurrencyWrapper";
import { Decimal } from "decimal.js";

function roundup(num: number, dec: number = 2) {
  const d = new Decimal(num).toFixed(2);
  return d;
}

export const valueAsMoney = (value: string) => {
  return roundup(Number(value));
};

export const valueTo2Decimals = valueAsMoney;

export const moneyToFormattedString = (
  value?: string | number,
  prefix = "$ ",
  errorText = "-"
): string => {
  value = value || value === 0 ? value?.toString() : "";

  const result = parseFloat(value);

  if (isNaN(result)) {
    return errorText;
  }
  return `${prefix}${valueAsMoney(value)}`;
};

const currencyWrapper = new CurrencyWrapper(currencies.AUD);

export function getCurrencyWrapper() {
  return currencyWrapper;
}

export * from "./types";
